import React from 'react';

const NotificationsPage = () => {
  return (
    <div className="crm-page">
      <div className="crm-breadcrumb">
        <span className="crm-breadcrumb__item">Рабочий стол</span>
        <span className="crm-breadcrumb__sep">›</span>
        <span className="crm-breadcrumb__item crm-breadcrumb__item--active">test</span>
      </div>
      <div className="crm-page-header">
        <h1 className="crm-page-title">test</h1>
      </div>
      <div style={{ padding: '24px', color: '#475569' }}>
        Раздел уведомлений пока не реализован, но вкладка снова доступна в меню.
      </div>
    </div>
  );
};

export default NotificationsPage;